/**
 * YouPage — the You tab: social and your profile (when turned on), settings, and search.
 */
import React from 'react';
import SubTabs from './layout/SubTabs';
import SocialPage, { ProfileView } from './SocialPage';
import Settings from './Settings';
import Search from './Search';

export default function YouPage({ sub, setSub, username, settingsProps, ...props }) {
  const { state, features } = props;
  const tabs = [
    ...(features.social ? [{ id: 'social', label: '🌐 Social' }, { id: 'profile', label: '👤 Profile' }] : []),
    { id: 'settings', label: '⚙️ Settings' },
    { id: 'search',   label: '🔍 Search' },
  ];
  const inner = tabs.some((t) => t.id === sub) ? sub : tabs[0].id;
  return (
    <div>
      <SubTabs tabs={tabs} active={inner} onChange={setSub} />
      {inner === 'social' && (
        <SocialPage
          state={{ ...state, _username: username }}
          showToast={props.showToast}
          updateState={props.updateState}
          features={features}
        />
      )}
      {inner === 'profile' && (
        <ProfileView username={username} showToast={props.showToast} storeEquipped={state.storeEquipped} />
      )}
      {inner === 'settings' && <Settings {...props} {...settingsProps} />}
      {inner === 'search' && <Search state={state} />}
    </div>
  );
}
